export const fontWeights = {
  normal: "400",
  bold: "600",
  extraBold: "700",
} as const;

export type FontWeightsKeys = keyof typeof fontWeights;
export type FontWeights = typeof fontWeights;
